import EDFError from './edf.error';

export default class FatalError extends EDFError {
    constructor(message, cause) {
        super(message, 'EDF:FatalError', cause);
    }
}
